// import logo from './logo.svg';
import { Box } from "@chakra-ui/react";
import "./App.css";
import About from "./Componants/AboutSection/About";
import Contact from "./Componants/ContactSection/Contact";
import GitStats from "./Componants/GitStates/GitStats";
import Home from "./Componants/HomeSection/Home";

import Navbar from "./Componants/Navbar/Navbar";
import Project from "./Componants/ProjectSection/Project";

import Skill from "./Componants/SkillsSection/Skill.jsx";

function App() {
  return (
    <Box className="App" mb={20}>
      <Navbar />

      <Home />
      <About />
      <Skill />
      <Project />
      <GitStats />
      <Contact />
    </Box>
  );
}

export default App;
